module.exports = __webpack_public_path__ + "img/img-9.b718f695.jpg";